import React from "react";
var style = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: 0,
  overflow: "hidden",
  position: "absolute"
};
export default (function (_ref) {
  var children = _ref.children;
  return React.createElement("span", {
    style: style,
    children: children
  });
});